import "../styles/questionformatFaq.css";
import { useEffect, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const QuestionFormatFaq = (props) => {
  const [allValid, setAllValid] = useState(false);
  const [toggleState, setToggleState] = useState({});
  const [anyButtonToggled, setAnyButtonToggled] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {}, [selectedValues]);

  useEffect(() => {
    setAllValid(anyButtonToggled);
  }, [anyButtonToggled]);

  useEffect(() => {
    const isAnyButtonToggled = Object.values(toggleState).some((state) => state);
    setAnyButtonToggled(isAnyButtonToggled);
  }, [toggleState]);

  const handleButtonClick = (faqId, faqValue) => {
    setToggleState((prevState) => ({
      ...prevState,
      [faqId]: !prevState[faqId],
    }));
    setSelectedValues((prevValues) => {
      if (toggleState[faqId]) {
        return prevValues.filter((value) => value !== faqValue);
      } else {
        return [...prevValues, faqValue];
      }
    });
  };

  return (
    <>
      <div className="">
        <div className="questionHeading mb20">{props.faqHeading}</div>

        <div className="questionsFormatFaqContainer">
          <div className="columnsContainer">
            {props.faqs && (
              <>
                <div className="column">
                  {props.faqs.slice(0, Math.ceil(props.faqs.length / 2)).map((faq) => (
                    <div key={faq.id} className="faqBtnContainer">
                      <div className={`faqBtn ${toggleState[faq.id] ? "faqBtn-inverted" : ""}`}>
                        <div className="faqLabel" onClick={() => handleButtonClick(faq.id, faq.value)}>
                          {faq.label}
                        </div>
                        {toggleState[faq.id] ? (
                          <FaMinus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        ) : (
                          <FaPlus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        )}
                      </div>
                      {toggleState[faq.id] && (
                        <div className="faqPanel">
                          <div>
                            {faq.value.split("\n").map((paragraph, index) => (
                              <p className="faqSpacer" key={index}>
                                {paragraph}
                              </p>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="column">
                  {props.faqs.slice(Math.ceil(props.faqs.length / 2)).map((faq) => (
                    <div key={faq.id} className="faqBtnContainer">
                      <div className={`faqBtn ${toggleState[faq.id] ? "faqBtn-inverted" : ""}`}>
                        <div className="faqLabel" onClick={() => handleButtonClick(faq.id, faq.value)}>{faq.label}</div>
                        {toggleState[faq.id] ? (
                          <FaMinus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        ) : (
                          <FaPlus className="faqIcon" onClick={() => handleButtonClick(faq.id, faq.value)} />
                        )}
                      </div>
                      {toggleState[faq.id] && (
                        <div className="faqPanel">
                          <div>
                            {faq.value.split("\n").map((paragraph, index) => (
                              <p className="faqSpacer" key={index}>
                                {paragraph}
                              </p>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionFormatFaq;
